import styled from 'styled-components';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';

export const WrapperBox = styled(Box)`
  max-width: 1670px;
  margin: auto;
`;

export const PhotosFlex = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    width: 540px;
    margin: auto;
  }
`;

export const StyledFlex = styled(Flex)`
  display: block;
`;

export const StyledTextPairing = styled(TextPairing)`
  text-align: center;
  display: block;
  .text-pairing-title {
    margin: 0 auto ${themeSpace(4)};
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 584px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 745px;
    }
  }
`;

export const StyledImageContainer = styled(CloudImage)<{ objectfit?: string }>`
  object-fit: ${props => (props.objectfit ? props.objectfit : 'cover')};
  ${themeMediaQuery('below_sm')} {
    object-fit: contain;
  }
`;

export const StyledImageWrapper = styled(Box)<{ width: number; height: number; reswidth: number; resheight: number }>`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  position: relative;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f6f4;
  ${themeMediaQuery('below_sm')} {
    padding: 6px;
    height: auto;
    width: ${props => props.reswidth}px;
    height: ${props => props.resheight}px;
  }
`;
